import Button from "components/Elements/Button/Button.js";
import React, { useState, useEffect } from "react";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { Toggle } from "components/Elements/Toggle/Toggle.js";

const SetFooterLinksModal = ({
  linkFooters,
  setLinkFooters,
  setEditCustomFooterLinks,
  editCustomFooterLinks,
  setDisplayFooterLinks,
  displayFooterLinks,
  hideDisplayToggle = null,
}) => {
  const { addToast } = useToasts();
  const { getTextByKey, getDirection } = useContent();
  const { closeModal } = useModal();
  const [title1, setTitle1] = useState("");
  const [title2, setTitle2] = useState("");
  const [title3, setTitle3] = useState("");
  const [link1, setLink1] = useState("");
  const [link2, setLink2] = useState("");
  const [link3, setLink3] = useState("");
  const [showFooters, setShowFooters] = useState(displayFooterLinks);
  useEffect(() => {
    if (linkFooters) {
      if (linkFooters.length > 0) {
        setTitle1(linkFooters[0].FooterLinkTitle);
        setLink1(linkFooters[0].FooterLinkUrl);
      }
      if (linkFooters.length > 1) {
        setTitle2(linkFooters[1].FooterLinkTitle);
        setLink2(linkFooters[1].FooterLinkUrl);
      }
      if (linkFooters.length > 2) {
        setTitle3(linkFooters[2].FooterLinkTitle);
        setLink3(linkFooters[2].FooterLinkUrl);
      }
    }
  }, [linkFooters]);

  const saveLinks = () => {
    let notUpdate = false;
    if (showFooters) {
      if (title1 === "" || title1 === null) {
        if (link1 && link1.length > 0) {
          notUpdate = true;
          addToast(getTextByKey("footer-empty-title"), {
            appearance: "error",
          });
        }
      }
      if (title2 === "" || title2 === null) {
        if (link2 && link2.length > 0) {
          notUpdate = true;

          addToast(getTextByKey("footer-empty-title"), {
            appearance: "error",
          });
        }
      }
      if (title3 === "" || title3 === null) {
        if (link3 && link3.length > 0) {
          notUpdate = true;

          addToast(getTextByKey("footer-empty-title"), {
            appearance: "error",
          });
        }
      }

      if (link1 === "" || link1 === null) {
        if (title1 && title1.length > 0) {
          notUpdate = true;

          addToast(getTextByKey("footer-empty-url"), {
            appearance: "error",
          });
        }
      }
      if (link2 === "" || link2 === null) {
        if (title2 && title2.length > 0) {
          notUpdate = true;

          addToast(getTextByKey("footer-empty-url"), {
            appearance: "error",
          });
        }
      }
      if (link3 === "" || link3 === null) {
        if (title3 && title3.length > 0) {
          notUpdate = true;

          addToast(getTextByKey("footer-empty-url"), {
            appearance: "error",
          });
        }
      }
    }
    if (!notUpdate) {
      let temp = [];
      title1 && temp.push({ FooterLinkTitle: title1, FooterLinkUrl: link1 });
      title2 && temp.push({ FooterLinkTitle: title2, FooterLinkUrl: link2 });
      title3 && temp.push({ FooterLinkTitle: title3, FooterLinkUrl: link3 });
      setLinkFooters(temp);
      for (let i = 0; i < linkFooters.length; i++) {
        const element = linkFooters[i];
        if (element) {
          if (i === 0) {
            if (
              title1 !== element.FooterLinkTitle ||
              link1 !== element.FooterLinkUrl
            ) {
              setEditCustomFooterLinks(true);
            }
          } else if (i === 1) {
            if (
              title2 !== linkFooters[1].FooterLinkTitle ||
              link2 !== linkFooters[1].FooterLinkUrl
            ) {
              setEditCustomFooterLinks(true);
            }
          } else if (i === 2) {
            if (
              title3 !== linkFooters[2].FooterLinkTitle ||
              link3 !== linkFooters[2].FooterLinkUrl
            ) {
              setEditCustomFooterLinks(true);
            }
          }
        }
      }

      if (!hideDisplayToggle) {
        if (showFooters) {
          setDisplayFooterLinks(true);
        } else {
          setDisplayFooterLinks(false);
        }
      }

      closeModal();
    }
  };

  return (
    <div className="footer-links-modal">
      <div
        className={`top-section ${
          getDirection() === "rtl" ? "rtl-footer" : ""
        }`}
      >
        <div className="modal-content">
          <div className="modal-body">
            <div className="title">
              {getTextByKey("edit-footer-links-title")}
            </div>
            <div className="links">
              <div className="set-links">
                <div className="title-link">
                  <span>{getTextByKey("edit-footer-title")}</span>
                  <input
                    value={title1}
                    onChange={(e) => setTitle1(e.target.value)}
                    type="text"
                  />
                </div>
                <div className="url-link">
                  <span>{getTextByKey("edit-footer-link")}</span>
                  <input
                    value={link1}
                    onChange={(e) => setLink1(e.target.value)}
                    type="text"
                  />
                </div>
              </div>
              <div className="set-links">
                <div className="title-link">
                  <span>{getTextByKey("edit-footer-title")}</span>
                  <input
                    value={title2}
                    onChange={(e) => setTitle2(e.target.value)}
                    type="text"
                  />
                </div>
                <div className="url-link">
                  <span>{getTextByKey("edit-footer-link")}</span>
                  <input
                    value={link2}
                    onChange={(e) => setLink2(e.target.value)}
                    type="text"
                  />
                </div>
              </div>
              <div className="set-links">
                <div className="title-link">
                  <span>{getTextByKey("edit-footer-title")}</span>
                  <input
                    value={title3}
                    onChange={(e) => setTitle3(e.target.value)}
                    type="text"
                  />
                </div>
                <div className="url-link">
                  <span>{getTextByKey("edit-footer-link")}</span>
                  <input
                    value={link3}
                    onChange={(e) => setLink3(e.target.value)}
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div className="actions">
              {!hideDisplayToggle && (
                <div className="toogle">
                  <Toggle status={showFooters} setStatus={setShowFooters} />
                  <span>{getTextByKey("display-footer-links")}</span>
                </div>
              )}
              <div className="buttons">
                <Button
                  blank
                  buttonClass="blank"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  {getTextByKey("cancel")}
                </Button>
                <Button
                  buttonClass="delete-form-button"
                  onClick={() => {
                    saveLinks();
                  }}
                >
                  {getTextByKey("save")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetFooterLinksModal;
